<template>
  <span>
    {{ currencyFormatter(totalNumber, { code: currency }) }}
  </span>
</template>

<script>
import totalPriceMixin from '@/mixins/pos/totalPrice'

export default {
  mixins: [totalPriceMixin],
}
</script>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/common/TotalPriceText.vue